/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2025-01-31",
    versionChannel: "nightly",
    buildDate: "2025-01-31T00:06:15.567Z",
    commitHash: "8d0879de13250e68d32fb13ffbb5094ba7b9c18a",
};
